import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./Offer0.css";
import { Navigation } from "swiper/modules";
import { VscArrowRight, VscArrowLeft } from "react-icons/vsc";
import { Link } from "react-router-dom";

const Offer0 = ({ data }) => {
  console.log("offer0-", data);

  const baseImageUrl =
    "https://grobizapp-n.s3.ap-south-1.amazonaws.com/offers/";

  const offers = data.get_home_component_details.content.map((item, index) => ({
    id: item._id,
    name: " ",
    price: item.price,
    offerPercent: item.offer,
    url: `/categorypage/${item._id}`,
    image: item.component_image
      ? `${baseImageUrl}${item.component_image}`
      : "https://via.placeholder.com/400",
  }));

  const truncateNameMobile = (name) => {
    return name.length > 15 ? name.substring(0, 15) + "..." : name;
  };

  const truncateNameDesktop = (name) => {
    return name.length > 25 ? name.substring(0, 25) + "..." : name;
  };
  const swiperRef_offer_0 = useRef(null);

  return (
    <div
      className="p-2 "
      style={{
        backgroundColor: data.web_background_color,
      }}
    >
      {" "}
      {/* Padding on both sides */}
      <h2
        className={`text-${data.title_alignment} p-3 ${data.web_title_font}`}
        style={{
          color: data.web_title_color,
        }}
      >
        {data.title}
      </h2>
      {/* Desktop View: 4 Cards per Row, No Gap, Fully Rounded */}
      <div className="relative flex-wrap justify-center hidden px-4 lg:flex">
        <Swiper
          ref={swiperRef_offer_0}
          slidesPerView={3}
          spaceBetween={5}
          loop={offers.length >= 4}
          watchOverflow={false}
          navigation={{
            nextEl: `.swiper-button-next-${data._id}`,
            prevEl: `.swiper-button-prev-${data._id}`,
          }}
          modules={[Navigation]}
          className="mySwiper"
        >
          {offers.map((offer) => (
            <SwiperSlide key={offer.id} style={{ minWidth: "450px" }}>
              <div className="flex justify-center">
                <Link
                  to={"/offerlist"}
                  state={{
                    offer_id: offer.id,
                  }}
                  className="text-decoration-none text-inherit"
                >
                  <div className="relative flex items-center text-center">
                    <img
                      src={offer.image}
                      alt={offer.name}
                      className="object-cover rounded-lg"
                      style={{ height: "580px", width: "auto" }}
                    />
                    {/* OFFER TAG */}
                    {offer.offerPercent && (
                      <div className="absolute z-20 top-3 left-3">
                        <div className="px-3 py-1 text-xs font-bold text-white rounded-full shadow-lg bg-gradient-to-r from-green-500 to-emerald-500">

                          UP TO {offer.offerPercent}% OFF
                        </div>
                      </div>
                    )}

                    <div className="absolute inset-0 rounded bg-gray-800/30"></div>
                    <div
                      className={`absolute top-1/2 left-1/2 -translate-x-1/2 text-white text-3xl font-bold uppercase text-center drop-shadow-lg ${data.web_title_font}`}
                    >
                      {truncateNameDesktop(offer.name)}
                    </div>
                  </div>
                </Link>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Arrows */}
        <div
          className={`swiper-button-prev-${data._id} swiper-button-prev-1 mx-20 p-2`}
        >
          <VscArrowLeft size={24} />
        </div>
        <div
          className={`swiper-button-next-${data._id} swiper-button-next-1 mx-20 p-2`}
        >
          <VscArrowRight size={24} />
        </div>
      </div>
      {/* Mobile View: Rounded Carousel with 4 Items */}
      <div className="grid justify-center grid-cols-2 gap-2 lg:hidden ">
        {offers.map((offer) => (
          <div key={offer.id} className="relative text-center">
            {/* Fully Rounded Image */}
            <Link
              to={"/offerlist"}
              state={{
                offer_id: offer.id,
              }}
              className="text-decoration-none text-inherit"
            >
              <img
                src={offer.image}
                alt={offer.name}
                className="object-cover rounded"
                style={{ height: "280px", width: "auto" }}
              />
              {offer.offerPercent && (
                <div className="absolute z-20 top-2 left-2">
                  <div className="px-2 py-0.5 text-[10px] font-bold text-white rounded-full bg-green-500 shadow">

                    {offer.offerPercent}% OFF
                  </div>
                </div>
              )}

            </Link>
            {/* Black Overlay (30% Opacity) */}
            <div className="absolute inset-0 rounded pointer-events-none bg-gray-800/30"></div>
            {/* Name Overlay Centered Over Image */}
            <div
              className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-lg font-bold uppercase drop-shadow-lg pointer-events-none ${data.web_title_font}`}
            >
              {truncateNameMobile(offer.name)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Offer0;